import keyBy from 'lodash/keyBy';
import groupBy from 'lodash/groupBy';
import type { State } from '../types';
import { CloudSiteTypeEnum } from '../../types';

/**
 * Convert to external cloud sites
 * @param productsAndAppData  - products and linkedEntitlements data
 */
export function convertToExternalCloudSites(productsAndAppData: Pick<State, 'products' | 'linkedEntitlements'> | null) {
  const products = Object.values(productsAndAppData?.products ?? {});

  const linkedEntitlements = Object.values(productsAndAppData?.linkedEntitlements ?? {}).flat(); // flat required for linkedEntitlements because linkedEntitlements structure is something like { containerOrProductId: [app1, app2] }
  // setting the cloudSiteType to external for the products
  products.forEach((product) => {
    if (product?.id) {
      product.cloudSiteType = CloudSiteTypeEnum.EXTERNAL;
    }
  });
  linkedEntitlements.forEach((app) => {
    if (app?.id) {
      app.cloudSiteType = CloudSiteTypeEnum.EXTERNAL;
    }
  });
  return { products: keyBy(products, 'id'), linkedEntitlements: groupBy(linkedEntitlements, 'containerOrProductId') };
}
